// Constants
export const FILE_MIN_WIDTH_GRID = 20;
